import { render, staticRenderFns } from "./empty-screen.vue?vue&type=template&id=d556ede4"
import script from "./empty-screen.vue?vue&type=script&lang=js"
export * from "./empty-screen.vue?vue&type=script&lang=js"
import style0 from "./empty-screen.vue?vue&type=style&index=0&id=d556ede4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports